import { createSwiperProductBlocks } from './base'

export function initAdvancedOrder() {
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
        setTimeout(() => {
            console.log('advanced order loaded')
            createSwiperProductBlocks('.advanced-order .products-block')
            $('.advanced-order .swiper-products-container').show()
        }, 10)
    })
}
